import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Axios from 'axios';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Dialog from 'material-ui/Dialog';
import 'react-toggle/style.css';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import getPath from 'lodash/get';
import Dots from 'react-activity/lib/Dots';

import {
  createEditorState,
  editorStateToRaw,
  editorStateToRawAndHtml,
  rawIsEmpty,
  htmlIsEmpty,
} from '../../../../helpers/editorStateHelper.js';

import styles from '../shared/styles';
import ImageCropModal from '../../../../components/ImageCropModal';
import { ActionButton } from '../../../../components/buttons/buttons';
import {
  canUserAccessFeature,
  canUserUse100PercenOffCoupon,
  hasUserExceededContentPlanLimit,
} from '../../../../helpers/userinfoHelper';
import { ALERTS } from '../../../../helpers/texts';
import userTour from '../../../../helpers/tour';
import {
  authManager,
  soundcastManager,
  soundcastExtManager,
  publisherManager,
  userManager,
  basicManager,
} from '../../../../helpers/managers';
const {
  podcastCategories,
  canPublisherAccessFeature,
  getRandomColor,
  isFreeAccount,
  trimSpaces,
  shortDescriptionPgCompatible,
} = require('../../../../../server/scripts/utils.js')();
import Status from './status';
import Title from '../shared/Title';
import Description from './description';
import Category from './category';
import CoverArt from './coverart';
import Features from './features';
import Hosts from './hosts';
import IntroOutro from './introoutro';
import Pricing from './pricing';
import OtherSettings from './othersettings';
import Subscription from './subscription';
import {
  findMinimumPriceIfPriceIsLessThanAllowed,
  hasDiscountsBelowMinimumPrice,
  hasValidCouponCodes,
} from '../../../../helpers/payments';
import { signupConfirmBodyTemplate } from '../../../../../server/scripts/helpers/emailTemplate';
import { soundcast2state } from '../soundcast_fields.js';

const categories = Object.keys(podcastCategories).map(i => podcastCategories[i].name);

class AddSoundcast extends Component {
  constructor(props) {
    super(props);

    const { editorState: long_description } = createEditorState();
    const {
      editorState: confirmationEmail,
      html: confirmationEmailHtml,
    } = createEditorState('', signupConfirmBodyTemplate());

    this.state = {
      ...soundcast2state(),

      soundcastId: `${moment().format('x')}s`,
      type: 'general',
      long_description,
      confirmationEmail,
      confirmationEmailHtml,
      userPlan: '',

      blurredImageURL: null, // ?
      previewImage: null, // ?
      showTimeStamps: true, // !!! false

      // itunesTitle: '', // ???
      // itunesOwner: '', // ???
      // itunesHost: '', // ???
      // itunesLanguage: 'en', // ???
      // itunesCategory: [], // ???
      // itunesExplicit: false, // ???
      // itunesImage: '', // ???

      // podcastFeedVersion: null,
      // autoSubmitPodcast: false,

      enableToggleTrackListOnLandingPage: canPublisherAccessFeature(
        this.props.userInfo.publisher,
        'SOUNDCAST_TRACKLIST_LANDING_TOGGLE'
      ),

      modal: {
        show: false,
        title: '',
        content: '',
        actionLabel: 'Upgrade',
        onClose: () => {},
        upgrade: false,
        dismissible: true,
      },
      imagecrop: {
        show: false,
        onCrop: () => {},
        onClose: () => {},
        file: null,
      },
      saving: false,
      strictmode: false,
    };

    this.saveSoundcast = this.saveSoundcast.bind(this);
    this.onAddSecondHostInstructor = this.onAddSecondHostInstructor.bind(this);
    this.onEditorStateChange = this.onEditorStateChange.bind(this);
    this.onSoundcastInputChange = this.onSoundcastInputChange.bind(this);
    this.onSoundcastStateChange = this.onSoundcastStateChange.bind(this);
    this.showIntroOutro = this.showIntroOutro.bind(this);
    this.modalHandler = this.modalHandler.bind(this);
    this.showModal = this.showModal.bind(this);
    this.handleChargeOption = this.handleChargeOption.bind(this);
    this.openImageCropModal = this.openImageCropModal.bind(this);
    this.closeImageCropModal = this.closeImageCropModal.bind(this);
    this.initFilepondImageCropperFor = this.initFilepondImageCropperFor.bind(this);
  }

  componentDidMount() {
    this.verifyPlanLimits();
  }

  componentWillReceiveProps(nextProps) {
    this.verifyPlanLimits(nextProps);
  }

  verifyPlanLimits(props = {}) {
    const { history } = props;
    if (hasUserExceededContentPlanLimit()) {
      this.restrictAccess();
      this.showModal({
        title: 'Upgrade Required',
        content: ALERTS().ALLOWED_SOUNDCASTS.LIMIT_EXCEEDED,
        upgrade: true,
        dismissible: false,
        onClose: () => {
          history.replace('/dashboard/soundcasts');
        },
      });
    }
  }

  areRequiredFieldsValid() {
    const { title, short_description, category } = this.state;
    return [title, short_description, category].every(value => !isEmpty(value));
  }

  restrictAccess() {
    this.setState({
      strictmode: true,
    });
  }

  saveSoundcast(published) {
    return () => {
      // before we proceed verify the required props first
      const canProceed = this.areRequiredFieldsValid();
      if (!canProceed) {
        return this.showModal({
          content: 'Please fill in all the required fields to continue.',
        });
      }

      this.setState({ saving: true }, () => {
        this.saveInternal(published);
      });
    };
  }

  async saveInternal(published) {
    let {
      soundcastId,
      title,
      short_description,
      long_description,
      imageURL,
      blurredImageURL,
      previewImage,
      landingPage,
      features,
      featuresTitle,
      hostTitle,
      hostName,
      hostBio,
      hostImageURL,
      hostName2,
      hostBio2,
      hostImageURL2,
      category,
      forSale,
      type,
      prices,
      confirmationEmail,
      confirmationEmailHtml,
      enableSignupEmail,
      showSubscriberCount,
      showListenCount,
      disableComment,
      showTrackListOnLandingPage,
      showTimeStamps,
      intro,
      outro,
      enableFaqOnLandingPage,
      enableRatings,
      disableSignup,
    } = this.state;
    const { userInfo, history } = this.props;

    if (isEmpty(title)) {
      return this.showModal({
        title: 'Soundcast Title is missing',
        content: 'Please enter a soundcast title before saving.',
        onClose: () => this.setState({ saving: false }),
      });
    }

    if (isEmpty(short_description)) {
      return this.showModal({
        title: 'Soundcast Description is missing',
        content: 'Please enter a short description for the soundcast before saving.',
        onClose: () => this.setState({ saving: false }),
      });
    }

    if (isEmpty(category)) {
      return this.showModal({
        title: 'Soundcast Category is missing',
        content: 'Please choose a category before saving.',
        onClose: () => this.setState({ saving: false }),
      });
    }

    // if pricing isn't specified, then this is a free soundcast
    // else the price needs to be at least stripe minimum charge amount
    const hasPrice = !isEmpty(prices);
    if (!hasPrice) {
      prices = [{ billingCycle: 'free', price: 'free' }];
    } else if (forSale) {
      const foundMinimumPrice = findMinimumPriceIfPriceIsLessThanAllowed(prices);

      if (!isEmpty(foundMinimumPrice)) {
        return this.showModal({
          title: 'Soundcast price is invalid',
          content: [
            `The price needs to be at least ${foundMinimumPrice.currency} ${foundMinimumPrice.price}`,
            <br key={`${soundcastId}br`} />,
            `0 price allowed only for "one time rental" payment`,
          ],
          onClose: () => this.setState({ saving: false }),
        });
      }
    }

    if (!canUserUse100PercenOffCoupon(prices)) {
      return this.showModal({
        title: 'Upgrade Required',
        content: ALERTS().SOUNDCAST_COUPONS_100POFF.NO_ACCESS,
        upgrade: true,
        onClose: () => this.setState({ saving: false }),
      });
    }

    // prices of discounts should be not lower than minimum
    if (hasDiscountsBelowMinimumPrice(prices)) {
      return this.showModal({
        title: 'Coupon discount',
        content: 'One of your coupon codes discounted price is below the minimum charge amount.',
        onClose: () => this.setState({ saving: false }),
      });
    }

    // prices has coupon but invalid
    if (!hasValidCouponCodes(prices)) {
      return this.showModal({
        title: 'Coupon Code',
        content: 'You have entered an invalid coupon code.',
        onClose: () => this.setState({ saving: false }),
      });
    }

    // ensure some limitations are applied
    landingPage = canUserAccessFeature('SOUNDCAST_PRIVATE') ? landingPage : true;
    if (prices.length > 0 && !canUserAccessFeature('SOUNDCAST_MULTIPLE_PRICING')) {
      prices = [prices[0]];
    }

    // for platinum users with white label, generate productSku
    // under format priceIndex_billingCycle_soundcastId
    if (canUserAccessFeature('MOBILE_WHITE_LABEL')) {
      prices = prices.map((price, index) => {
        if (!('billingCycle' in price)) return price;
        return {
          ...price,
          productSku: `${index}_${trimSpaces(price.billingCycle)}_${soundcastId}`,
        };
      });
    }

    if (!canUserAccessFeature('SOUNDCAST_INTRO_OUTRO')) {
      intro = '';
      outro = '';
    }

    // get current user
    const user = authManager.getCurrentUser();
    if (user) {
      // set imageURL if empty
      imageURL = isEmpty(imageURL)
        ? `https://dummyimage.com/300.png/${getRandomColor()}/ffffff&text=${encodeURIComponent(
            title
          )}`
        : imageURL;

      const creatorID = user.uid;
      const last_update = Number(moment().format('X'));
      let newSoundcast = {
        title,
        short_description: shortDescriptionPgCompatible(short_description),
        imageURL,
        // blurredImageURL,
        // previewImage,
        landingPage,
        features,
        featuresTitle,
        hostTitle,
        hostName,
        hostBio,
        hostImageURL,
        hostName2,
        hostBio2,
        hostImageURL2,
        category,
        forSale,
        type,
        prices,
        confirmationEmail: null, // deprecated in soundcasts
        enableSignupEmail,
        ...(showSubscriberCount ? { showSubscriberCount } : { showSubscriberCount: null}),
        showListenCount,
        disableComment,
        showTrackListOnLandingPage,
        showTimeStamps,
        intro,
        outro,
        enableFaqOnLandingPage,
        enableRatings,
        disableSignup,

        // mandatory props
        published,
        creatorID,
        publisherID: userInfo.publisherID,
        date_created: moment().format('X'),
        last_update,
      };

      try {
        const longDescriptionRaw = editorStateToRaw(long_description);
        if (!rawIsEmpty(longDescriptionRaw)) {
          newSoundcast.long_description = JSON.stringify(longDescriptionRaw);
        }
        
        const {
          raw: confirmationEmailRaw,
          html: confirmationEmailHtmlNew,
        } = editorStateToRawAndHtml(confirmationEmail);
        const isNeedSaveConfirmationEmail = !isEqual(confirmationEmailHtml, confirmationEmailHtmlNew);

        const requests = [
          new Promise((resolve, reject) => {
            // add soundcast to publisher
            publisherManager
              .saveProp(userInfo.publisherID, `soundcasts/${soundcastId}`, true)
              .then(resolve)
              .catch(err => {
                console.log('ERROR occured when adding soundcast to publisher: ', err);
                reject(err);
              });
          }),
          new Promise((resolve, reject) => {
            // add soundcast to owner or administrators
            const { administrators = {} } = userInfo.publisher;

            const administratorIds = Object.entries(administrators)
              .filter(([, value]) => value !== false && value !== null)
              .map(([key]) => key);

            const nodeUpdates = administratorIds.reduce((admins, adminId) =>
              {
                if ( adminId !== creatorID) {

                  admins[`users/${adminId}/soundcasts_managed/${soundcastId}`] = true;
                }
                return admins;
              },
              {
                [`publishers/${userInfo.publisherID}/soundcasts/${soundcastId}`]: true,
                [`users/${creatorID}/soundcasts_managed/${soundcastId}`]: true,
              }
            );

            basicManager
              .update(nodeUpdates)
              .then(resolve)
              .catch(err => {
                console.log(`ERROR occured when adding soundcast to owner and administrators: ${JSON.stringify(err)}`);
                reject(err);
              });
          }),
          new Promise(async (resolve, reject) => {
            try {
              await Axios.post('/api/soundcast', {
                title,
                soundcastId,
                shortDescription: shortDescriptionPgCompatible(short_description),
                publisherId: userInfo.publisherID,
                imageUrl: imageURL,
                previewImage,
                category,
                published,
                landingPage,
                forSale,
                updateDate: last_update,
                hostName,
              });
              resolve();
            } catch (err) {
              console.log('ERROR API post soundcast: ', err);
              reject(err);
            }
          }),
        ];

        if (isNeedSaveConfirmationEmail) {
          // save only if the template differs from the default one
          requests.push(
            new Promise((resolve, reject) => {
              soundcastExtManager
                .saveProp(soundcastId, 'confirmationEmail', JSON.stringify(confirmationEmailRaw))
                .then(resolve)
                .catch(err => {
                  console.log('ERROR occured when saving soundcast ext data: ', err);
                  reject(err);
                });
            }),
          );
        }

        // adding soundcast to firebase should be done first
        await new Promise((resolve, reject) => {
          // add the soundcast
          soundcastManager
            .update(soundcastId, newSoundcast)
            .then(resolve)
            .catch(err => {
              console.log('ERROR occured when adding soundcast: ', err);
              reject(err);
            });
        });
        // process soundcast creation - other entities
        await Promise.all(requests);

        // if there are prices, update plans
        let stripePlansError = '';
        if (prices.length && userInfo.publisher && userInfo.publisher.stripe_user_id) {
          const postBody = {
            soundcastID: soundcastId,
            publisherID: userInfo.publisherID,
            stripe_account: userInfo.publisher.stripe_user_id,
            title,
            prices: landingPage && forSale ? prices : [],
          };
          try {
            await Axios.post('/api/createUpdatePlans', postBody);
          } catch (err) {
            const errorMessage = getPath(err, 'response.data',
              'Something went wrong when requesting data to server. ' +
              (err && err.message || 'Unknown error'),
            );
            console.warn(`WARNING: createUpdatePlans errored `, errorMessage, JSON.stringify(postBody) );
            stripePlansError = ` With stripe warning: ${errorMessage}`;
          }
        }

        // if success show a message
        if (userTour.available()) {
          userTour.setUserProp('createdSoundcast', true);
        }

        this.showModal({
          content: 'Your new soundcast has been successfully created.' + stripePlansError,
          onClose: () => history.push('/dashboard/soundcasts'),
        });
      } catch (err) {
        console.log('failed to complete adding soundcast', err.message);
        this.showModal({
          title: 'Error Creating Soundcast',
          content: 'There was a problem creating your soundcast, please contact support.',
        });
      } finally {
        this.setState({ saving: false });
      }
    }
  }

  onAddSecondHostInstructor(state = true) {
    return () => {
      const additional = !state
        ? {
            hostName2: '',
            hostBio2: '',
            hostImageURL2: '',
          }
        : {};

      this.setState({
        instructor2Input: state,
        ...additional,
      });
    };
  }

  isShownSoundcastSignup() {
    const { userInfo } = this.props;
    if (userInfo.publisher.plan === 'basic') {
      return true;
    }

    if (this.state.published === true) {
      if (!this.state.forSale) {
        return true;
      }
      if (
        this.state.forSale === true &&
        !isFreeAccount(userInfo) &&
        (userInfo.publisher.plan === 'plus' ||
          userInfo.publisher.plan === 'pro' ||
          userInfo.publisher.plan === 'platinum') &&
        userInfo.publisher.current_period_end > moment().format('X')
      ) {
        return true;
      }
    }
    return false;
  }

  onSoundcastInputChange(key = 'title') {
    return e => {
      const input = e.target.value;
      this.setState({
        [key]: input || '',
      });
    };
  }

  onSoundcastStateChange(key = 'title', value = '', cb = () => {}) {
    return () => {
      const oldstatevalue = this.state[key];
      this.setState({ [key]: value }, () => {
        cb(oldstatevalue);
      });
    };
  }

  deleteFeature(i) {
    const features = [...this.state.features];
    if (features.length >= 2) {
      features.splice(i, 1);
    } else {
      features[0] = '';
    }
    this.setState({
      features,
    });
  }

  handleChargeOption() {
    const { forSale } = this.state;
    const { userInfo } = this.props;

    if (!forSale) {
      if (!userInfo.publisher.stripe_user_id) {
        this.saveInternal(false);
        this.showModal({
          title: `Hold on, ${userInfo.firstName}! Please set up your payout first.`,
          content: `You need a payout account so that we could send you your sales proceeds. Please
                  save this soundcast, and go to publisher setting to enter your payout method,
                  before setting up soundcast pricing.`,
        });
      } else {
        this.setState({
          forSale: !forSale,
          prices: [{ paymentPlan: '', billingCycle: 'one time', price: 1, currency: 'USD' }],
        });
      }
    } else {
      this.setState({
        forSale: !forSale,
        prices: [{ billingCycle: 'free', price: 'free' }],
      });
    }
  }

  onEditorStateChange(statekey) {
    return editorState => {
      this.setState({ [statekey]: editorState });
    };
  }

  showIntroOutro() {
    if (!canUserAccessFeature('SOUNDCAST_INTRO_OUTRO')) {
      return this.showModal({
        title: 'Upgrade Required',
        content: ALERTS().SOUNDCAST_INTRO_OUTRO.NO_ACCESS,
        upgrade: true,
      });
    }

    this.setState(({ showIntroOutro }) => ({
      showIntroOutro: !showIntroOutro,
    }));
  }

  renderImageCropModal() {
    const { show, onCrop, onClose, file } = this.state.imagecrop;
    return <ImageCropModal open={show} handleClose={onClose} onCrop={onCrop} file={file} />;
  }

  openImageCropModal(metadata) {
    this.setState({
      imagecrop: {
        show: true,
        onClose: this.closeImageCropModal,
        ...metadata,
      },
    });
  }

  closeImageCropModal() {
    this.openImageCropModal({
      show: false,
    });
  }

  initFilepondImageCropperFor(options) {
    this.openImageCropModal(
      options({
        close: this.closeImageCropModal,
      })
    );
  }

  renderHostInformation() {
    const {
      hostTitle,
      hostName,
      hostName2,
      hostBio,
      hostBio2,
      hostImageURL,
      hostImageURL2,
      instructor2Input,
      soundcastId,
    } = this.state;

    const list = [
      {
        hostName,
        hostBio,
        hostImageURL,
      },
    ];

    if (instructor2Input || !isEmpty(hostName2)) {
      list.push({
        hostName: hostName2,
        hostBio: hostBio2,
        hostImageURL: hostImageURL2,
      });
    }

    return (
      <Hosts
        soundcastId={soundcastId}
        hostTitle={hostTitle}
        list={list}
        onAdd={this.onAddSecondHostInstructor()}
        onRemove={this.onAddSecondHostInstructor(false)}
        onChange={(statekey, value) => this.onSoundcastStateChange(statekey, value)()}
        withCrop={true}
        cropperHandler={this.initFilepondImageCropperFor}
        persistUploaderOnSuccess={true}
        autoDeletePrevious={false}
        autoSave={false}
      />
    );
  }

  renderIntroOutro() {
    const {
      showIntroOutro,
      intro,
      outro,
      soundcastId,
      overlayDuration,
      applyHistoricallyIntroOutro,
    } = this.state;
    const { userInfo } = this.props;
    return (
      <IntroOutro
        publisherId={userInfo.publisherID}
        soundcastId={soundcastId}
        show={showIntroOutro}
        showHistoricalToggle={false}
        intro={intro}
        outro={outro}
        onChange={(statekey, value) => this.onSoundcastStateChange(statekey, value)()}
        handleShow={this.showIntroOutro}
        persistUploaderOnSuccess={true}
        autoSave={false}
        overlayDuration={overlayDuration}
        applyHistoricallyIntroOutro={applyHistoricallyIntroOutro}
        onNoIntroOutroAlert={() => {
          this.showModal({
            title: 'Missing intro or outro requirements',
            content: 'Please upload intro/outro clip(s) to your soundcast to use this feature.',
          });
        }}
      />
    );
  }

  renderPricingOptions() {
    const { landingPage, forSale, prices, userPlan, soundcastId } = this.state;

    return (
      <Pricing
        public={landingPage}
        forsale={forSale}
        prices={prices}
        userPlan={userPlan}
        soundcastId={soundcastId}
        onEnableCharge={this.handleChargeOption}
        onPricesUpdate={prices => this.onSoundcastStateChange('prices', prices)()}
        showModal={this.showModal}
      />
    );
  }

  renderOtherSettings() {
    const {
      soundcastId,
      showTimeStamps,
      showSubscriberCount,
      showListenCount,
      disableComment,
      showTrackListOnLandingPage,
      enableToggleTrackListOnLandingPage,
      enableFaqOnLandingPage,
      enableRatings,
      disableSignup,
    } = this.state;

    return (
      <OtherSettings
        soundcastId={soundcastId}
        showTimeStamps={showTimeStamps}
        showSubscriberCount={showSubscriberCount}
        showListenCount={showListenCount}
        disableComment={disableComment}
        showTrackListOnLandingPage={showTrackListOnLandingPage}
        enableToggleTrackListOnLandingPage={enableToggleTrackListOnLandingPage}
        enableFaqOnLandingPage={enableFaqOnLandingPage}
        enableRatings={enableRatings}
        disableSignup={disableSignup}
        onChange={(statekey, value) => this.onSoundcastStateChange(statekey, value)()}
        onClickUpgrade={() => this.props.history.push('/pricing')}
      />
    );
  }

  modalHandler(metadata = {}) {
    let {
      show = false,
      title = '',
      content = '',
      upgrade = false,
      onClose = false,
      dismissible = true,
    } = metadata;

    return () => {
      let { onClose: oldClose } = this.state.modal;
      this.setState(
        {
          modal: {
            ...this.state.modal,
            show,
            title,
            content,
            upgrade,
            dismissible,
            onClose: !show ? false : onClose,
          },
        },
        () => {
          if (oldClose && !show) {
            oldClose();
          }
        }
      );
    };
  }

  showModal(metadata = {}) {
    this.modalHandler({
      show: true,
      ...metadata,
    })();
  }

  renderAlertModal() {
    const { show, title, content, upgrade, dismissible = true, onClose } = this.state.modal;
    const actionLabel = upgrade ? 'Upgrade' : 'OK';
    const actionBtnClick = upgrade
      ? () => this.props.history.push('/pricing')
      : this.modalHandler({ show: false });
    const actions = [
      <div style={{ textAlign: 'center', padding: 20 }}>
        <ActionButton id="actionButtonTest1" onClick={actionBtnClick}>
          {actionLabel}
        </ActionButton>
        {upgrade && (
          <ActionButton
            textColor="#f76b1c"
            backgroundColor="#fff"
            onClick={() => {
              this.modalHandler({ show: false })();
              if (onClose) {
                onClose();
              }
            }}>
            Cancel
          </ActionButton>
        )}
      </div>,
    ];

    return (
      <Dialog
        title={
          <div className="title-medium" style={{ fontWeight: 800, textAlign: 'center' }}>
            {title}
          </div>
        }
        actions={actions}
        modal={!dismissible}
        open={show}
        onRequestClose={this.modalHandler({ show: false })}>
        <div className="title-small" style={{ textAlign: 'center', padding: '0 20px' }}>
          {content}
        </div>
      </Dialog>
    );
  }

  renderSaveButtons() {
    const { saving } = this.state;

    let content = (
      <div className="col-lg-12" style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 17, width: '100%', marginTop: 50 }}>
          <span>Saving</span>
        </div>
        <div className="" style={{ marginTop: 10, width: '100%' }}>
          <Dots color="#727981" size={32} speed={1} />
        </div>
      </div>
    );

    if (!saving) {
      content = (
        <React.Fragment>
          <div className="col-lg-12" style={{ textAlign: 'center' }}>
            <div
              id="saveDraftSoundcastBtnTest"
              className="btn"
              style={styles.draftButton}
              onClick={this.saveSoundcast(false)}>
              <span>Save Draft</span>
            </div>
          </div>
          <div className="col-lg-12" style={{ textAlign: 'center' }}>
            <div
              id="savePublishSoundcastBtnTest"
              className="btn btn-default"
              style={{ ...styles.draftButton, ...styles.publishButton }}
              onClick={this.saveSoundcast(true)}>
              <span>Publish</span>
            </div>
          </div>
        </React.Fragment>
      );
    }

    return <div style={styles.actionButtonWrapper}>{content}</div>;
  }

  renderBody() {
    const {
      soundcastId,
      landingPage,
      title,
      short_description,
      long_description,
      category,
      imageURL,
      features,
      featuresTitle,
      confirmationEmail,
      enableSignupEmail,
      strictmode,
    } = this.state;
    const { userInfo } = this.props;

    if (strictmode) {
      return null;
    }

    return (
      <div style={{ minHeight: window.innerHeight - 83 - 70 }}>
        <div style={{ padding: '20px' }}>
          <Status
            soundcastId={soundcastId}
            public={landingPage}
            onStatusChange={(statekey, value) => this.onSoundcastStateChange(statekey, value)()}
            viewLinks={false}
          />
          <Title value={title} required={true} onChange={this.onSoundcastInputChange('title')} />
          <Description
            id="short_description"
            label="Short Description"
            required={true}
            value={short_description}
            placeholder="A short description of this soundcast (300 characters max)"
            helper="300 characters max"
            onChange={this.onSoundcastInputChange('short_description')}
          />
          <Category
            required={true}
            list={categories}
            value={category}
            onChange={category => this.onSoundcastStateChange('category', category)()}
          />
          <CoverArt
            publisherId={userInfo.publisherID}
            soundcastId={soundcastId}
            value={imageURL}
            datakey="imageURL"
            datakeyBlur="blurredImageURL"
            datakeyPreview="previewImage"
            withCrop={true}
            withBlur={true}
            withPreview={true}
            cropperHandler={this.initFilepondImageCropperFor}
            persistUploaderOnSuccess={true}
            autoDeletePrevious={false}
            autoSave={false}
            onChange={(statekey, value) => this.onSoundcastStateChange(statekey, value)()}
          />
          <Features
            label="Features Section"
            helper="(list the main benefits and features of this soundcast)"
            placeholder="e.g. Learn how to analyze financial statement with ease"
            list={features}
            onChange={features => this.onSoundcastStateChange('features', features)()}
            onTitleChange={value => {
              this.setState({
                featuresTitle: value || '',
              });
            }}
            title={featuresTitle}
            enableEnterAdd={true}
          />
          <Description
            id="long_description"
            label="Long Description"
            value={long_description}
            onChange={this.onEditorStateChange('long_description')}
            richEditor={true}
          />
          {this.renderHostInformation()}
          {this.renderIntroOutro()}
          {this.renderPricingOptions()}
          {this.renderOtherSettings()}
          <Subscription
            signupEmailValue={confirmationEmail}
            onChangeSignupEmail={this.onEditorStateChange('confirmationEmail')}
            onResetToDefaultEmail={() => {
              const {
                editorState: confirmationEmail,
                html: confirmationEmailHtml,
              } = createEditorState('', signupConfirmBodyTemplate());
              this.setState({
                confirmationEmail,
                confirmationEmailHtml,
              });
            }}
            enableSignupEmail={enableSignupEmail}
            onChangeSignupEmailToggle={value =>
              this.onSoundcastStateChange('enableSignupEmail', value)()
            }
          />
          {this.renderSaveButtons()}
        </div>
      </div>
    );
  }

  render() {
    return (
      <MuiThemeProvider>
        <div>
          <div style={styles.topHeaderWrapper}>
            <div className="row">
              <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
                <div style={styles.topHeaderSwitcher}>
                  <div className="title-medium">Add Soundcast</div>
                </div>
              </div>
            </div>
          </div>
          {this.renderBody()}
          {this.renderAlertModal()}
          {this.renderImageCropModal()}
        </div>
      </MuiThemeProvider>
    );
  }
}

AddSoundcast.propTypes = {
  userInfo: PropTypes.object,
  history: PropTypes.object,
};

export default AddSoundcast;
